import { useKeycloak } from "@react-keycloak/web";
import React, { useContext } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import GlobalEventListener from "../Uitls/GlobalEventListener";
import MlrStatusEventListener from "../Uitls/MlrStatusEventListener";
import SessionExpiryManager from "../components/ModulePreview/SessionExpiryManager";
import ValueContext from "../ContextAPi/appContext";

const KeyCloakPrivateRoute = ({
  component: Component,
  canAccessedBy,
  role,
  editorRoute,
  ...rest
}) => {
  const appData = useContext(ValueContext);
  const { initialized, keycloak } = useKeycloak();
  const currentLocation = useLocation();
  if (!initialized) {
    return <div>Loading...</div>;
  }

  const hasAccess = () => {
    // not having canAccessedBy as props, will be treated as a whitelisted route for all
    if (!canAccessedBy) {
      return true;
    }
    const userRoles = keycloak.realmAccess.roles; //window.localStorage.getItem("userRole") || "";

    for (let i = 0; i < userRoles.length; i++) {
      if (canAccessedBy.includes(userRoles[i])) {
        return true;
      }
    }
    return false;
  };
  const isLoggedIn = keycloak.authenticated && hasAccess();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isLoggedIn) {
          return (
            <>
              <MlrStatusEventListener/>
              <GlobalEventListener />
              <SessionExpiryManager 
                editorRoute={editorRoute}
              />
              <Component {...props}
              />
            </>
          );
        } else {
          return (
            <Redirect to={{ pathname: "/", state: currentLocation || "" }} />
          );
        }
      }}
    />
  );
};

export default KeyCloakPrivateRoute;
